// 3rd party imports
import * as React from 'react';

// ui
import { LocalizedText } from '@shared-ui/localization-context';
import { UitkHeading, UitkText } from 'uitk-react-text';

// components
import { AffiliateCTA } from '../affiliate-cta';
import { UitkButtonSize } from 'uitk-react-button';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

// utils
import { useStores } from 'hooks';
import { getUserAnalyticsMicroMessage } from '../../util/analytics';

function ApplyNow() {
  const { analytics, userAuth, pzStore } = useStores();

  const referrerId = 'affhub_home_bottom_join_now.selected';
  const linkName = 'AffHub Home Bottom Join Now Selected';

  const trackSelect = {
    id: referrerId,
    callback: () => {
      if (analytics && typeof analytics.trackEvent === 'function') {
        analytics.trackEvent(referrerId, linkName, null, null, true, [
          getUserAnalyticsMicroMessage(userAuth?.currentUserDetails, pzStore?.pzPublisher),
        ]);
      }
    },
  };

  return (
    <div className="ApplyNow container">
      <UitkLayoutFlex space="six" direction="column" alignItems="center">
        <UitkLayoutFlexItem>
          <UitkHeading tag="h1" size={4} align="center">
            <LocalizedText message="home.apply-now.heading.apply_now" />
          </UitkHeading>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <UitkText className="ApplyNow__descritpion" align="center">
            <LocalizedText message="home.apply-now.content.reach_bigger_audience" />
          </UitkText>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <AffiliateCTA size={UitkButtonSize.LARGE} analyticsConfig={trackSelect} />
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </div>
  );
}

export { ApplyNow };
